module.exports = __webpack_public_path__ + "img/screen-img-01.fabc3aaf.jpg";